<template>
    <div class="wholesaler-text text-size-5">
        <div class="content mt rounded hidden-md-down overflow-hidden">
            <div class="pos-relative bg-default-1 aspect" style="padding-bottom: 24%">
                <img
                    :data-src="`${imagesPath}2021_02_paginalojistas_desktop_topo_v2.png?auto=compress,format&q=65`"
                    class="img-responsive lazy lazy-fade"
                />

                <div
                    class="pos-absolute px-5 pos-center-y text-primary-5 py-5 d-flex flex-justify-center"
                >
                    <div>
                        <h1 class="mt-0">Chico Rei para Lojistas</h1>
                        <p>
                            <strong> Sem pepinos, sem dificuldades, jogo rápido ;) </strong>
                        </p>
                        <p>
                            Você faz o seu cadastro e já acessa as condições
                            <br />
                            de compra como revenda oficial Chico Rei!
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="hidden-md-up">
            <div class="pos-relative bg-default-1 aspect" style="padding-bottom: 39.06%">
                <img
                    :data-src="`${imagesPath}2021_02_paginalojistas_mobile_topo_v2.png?auto=compress,format&q=65`"
                    class="img-responsive lazy lazy-fade"
                />

                <div
                    class="pos-absolute pos-center-y text-primary-5 py-5 d-flex flex-justify-center"
                >
                    <div class="content">
                        <h1 class="h2 my-0">
                            Chico Rei <br />
                            para Lojistas
                        </h1>
                    </div>
                </div>
            </div>

            <div class="content text-primary-5 py-4 d-flex flex-justify-center">
                <div>
                    <p>
                        <strong> Sem pepinos, sem dificuldades, jogo rápido ;) </strong>
                    </p>
                    <p>
                        Você faz o seu cadastro e já acessa as condições de compra como revenda
                        oficial Chico Rei!
                    </p>
                </div>
            </div>
        </div>

        <div class="content">
            <div
                class="hidden-sm-down d-flex flex-wrap flex-justify-center text-size-4 text-yanone py"
            >
                <template v-for="(item, i) in summary">
                    <a class="cursor-pointer" @click="scrollTo(item.ref)">{{ item.label }}</a>
                    <template v-if="i === Math.floor(summary.length / 2)">
                        <div class="hidden-lg-down mx-2">&bull;</div>
                        <div class="hidden-lg-up" style="flex: 0 0 100%" />
                    </template>
                    <div v-else-if="i < summary.length - 1" class="mx-2">&bull;</div>
                </template>
            </div>

            <hr class="my-0" />

            <div class="flex-grid">
                <div class="flex-md-10 flex-md-offset-1">
                    <div class="mb-8">
                        <div ref="products" class="anchor"></div>
                        <h2 class="h1 text-center">Produtos</h2>

                        <div class="hidden-md-down">
                            <div
                                class="d-flex my-4 text-size-4 text-italic text-bold text-underline flex-justify-center"
                            >
                                <div
                                    v-for="type in productTypes"
                                    class="mx-4 cursor-pointer"
                                    :class="{
                                        'text-info-5': type === selectedProductType,
                                        'text-default-3': type !== selectedProductType,
                                    }"
                                    @click="selectedProductType = type"
                                >
                                    {{ type.title }}
                                </div>
                            </div>
                            <div
                                class="pos-relative bg-default-1 aspect-xs-16-9 aspect-md-21-9 rounded"
                            >
                                <div class="pos-absolute pos-all">
                                    <img
                                        v-for="type in productTypes"
                                        v-show="selectedProductType === type"
                                        :src="
                                            imagesPath +
                                            type.images.desktop +
                                            '?auto=compress,format&q=65'
                                        "
                                        :key="type.images.desktop"
                                        class="w-full h-full"
                                        style="object-fit: cover"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="hidden-md-up">
                            <div
                                class="horizontal-list text-size-4 text-italic text-bold text-underline no-scrollbar"
                                @scroll="productsScrollEvent = $event"
                                id="product-types-list"
                            >
                                <div
                                    v-for="type in productTypes"
                                    class="pos-relative bg-default-1 aspect-xs-16-9 rounded w-full"
                                >
                                    <div class="pos-absolute pos-all">
                                        <img
                                            :data-src="
                                                imagesPath +
                                                type.images.mobile +
                                                '?auto=compress,format&q=65'
                                            "
                                            class="w-full h-full lazy lazy-fade"
                                            style="object-fit: cover"
                                        />
                                    </div>
                                </div>
                            </div>
                            <horizontal-scrollbar
                                id-list="product-types-list"
                                :scroll-event="productsScrollEvent"
                            />
                        </div>
                    </div>

                    <div class="my-8 text-center">
                        <div ref="signUp" class="anchor"></div>
                        <h2 class="h1">Junte-se a nós</h2>

                        <form action="cadastrar" method="post" class="form-horizontal">
                            <input class="hidden" name="tipo_pessoa" value="1" type="hidden" />
                            <input class="hidden" name="lojista" value="1" type="hidden" />
                            <input
                                type="submit"
                                class="btn btn-primary btn-xl"
                                value="Faça agora o seu cadastro"
                            />
                        </form>
                    </div>

                    <div class="my-8">
                        <div ref="conditions" class="anchor"></div>
                        <h2 ref="conditions" class="h1 text-center">Condições</h2>

                        <div class="flex-grid flex-align-stretch">
                            <div v-for="condition in conditions" class="flex-sm-6">
                                <div class="frame px py d-flex flex-align-center h-full">
                                    <div class="pos-relative mr" style="flex: 0 0 70px">
                                        <div class="aspect aspect-xs-1-1">
                                            <div
                                                class="rounded-full pos-absolute pos-all bg-primary-1 mx-2 my-2 px-2 py-2"
                                            >
                                                <div
                                                    class="img-responsive wholesaler-condition-icon bg-primary-5 w-full h-full"
                                                    :style="{
                                                        maskImage: `url(\'${
                                                            imagesPath +
                                                            condition.icon +
                                                            '?auto=compress,format&q=65'
                                                        }\')`,
                                                    }"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p v-for="item in condition.items">
                                            {{ item }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex flex-justify-center text-medium mt-4">
                            <p class="mx">* Necessita análise</p>
                            <p class="mx">** Sem análise</p>
                        </div>
                    </div>

                    <div class="my-8">
                        <div ref="social" class="anchor"></div>
                        <h2 class="h1 text-center">Empreender e gerar impacto social positivo</h2>

                        <div>
                            <div class="flex-grid flex-align-center">
                                <div class="flex-lg-7 flex-xl-8">
                                    <div class="bg-default-1 aspect aspect-xs-16-9 rounded">
                                        <picture>
                                            <source
                                                media="(min-width: 768px)"
                                                :data-srcset="`${imagesPath}2021_02_paginalojistas_desktop_penitenciaria.png?w=1250&auto=compress,format&q=65`"
                                            />
                                            <img
                                                :data-src="`${imagesPath}2021_02_paginalojistas_desktop_penitenciaria.png?w=1000&auto=compress,format&q=65`"
                                                class="lazy lazy-fade"
                                            />
                                        </picture>
                                    </div>
                                </div>
                                <div class="flex-lg-5 flex-xl-4">
                                    <div class="pl">
                                        <p>
                                            Somos meio de transformação social e queremos que você
                                            entre nessa ciranda. Através do nosso selo
                                            <strong>“Camisetas Mudam o Mundo”</strong>,
                                            transformamos a nossa sociedade.
                                        </p>
                                        <p>
                                            Acreditamos no papel de empresas que acreditam em um
                                            capitalismo cada vez mais consciente, inclusivo e justo.
                                        </p>
                                        <p>
                                            <a
                                                class="text-primary-5 text-bold text-italic"
                                                href="/camisetas-mudam-o-mundo"
                                                target="_blank"
                                            >
                                                Conheça o nosso projeto
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="my-8">
                        <div ref="collections" class="anchor"></div>
                        <h2 class="h1 text-center">Somos uma rede de pessoas sensacionais</h2>

                        <div class="hidden-md-down flex-grid">
                            <div v-for="banner in partnersBanners" class="flex-sm-4">
                                <div class="bg-default-1 rounded aspect-xs-16-9">
                                    <img
                                        :data-src="
                                            imagesPath + banner + '?w=400&auto=compress,format&q=65'
                                        "
                                        class="lazy lazy-fade"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="hidden-md-up">
                            <div
                                class="horizontal-list no-scrollbar"
                                @scroll="partnersScrollEvent = $event"
                                id="partners-list-hs"
                            >
                                <div
                                    v-for="banner in partnersBanners"
                                    class="pos-relative bg-default-1 rounded aspect-xs-16-9 w-full"
                                >
                                    <div class="pos-absolute pos-all">
                                        <img
                                            :data-src="
                                                imagesPath +
                                                banner +
                                                '?w=1000&auto=compress,format&q=65'
                                            "
                                            class="w-full h-full lazy lazy-fade"
                                            style="object-fit: cover"
                                        />
                                    </div>
                                </div>
                            </div>
                            <horizontal-scrollbar
                                id-list="partners-list-hs"
                                :scroll-event="partnersScrollEvent"
                            ></horizontal-scrollbar>
                        </div>

                        <p class="wholesaler-partners-text mx-auto mt-3">
                            Todos os meses lançamos coleções oficiais. São mais de 30 artistas e
                            marcas reconhecidas mundialmente:
                            <strong
                                >Milton Nascimento, Gilberto Gil, Frida Kahlo, Elza Soares, Popeye,
                                SOS Mata Atlântica</strong
                            >
                            e muito mais!
                        </p>
                    </div>

                    <div class="my-8">
                        <div ref="badges" class="anchor"></div>
                        <h2 class="h1 text-center">Selos de Responsabilidade</h2>

                        <div
                            v-for="badge in badges"
                            class="frame my-4 wholesaler-badge d-flex flex-align-center flex-column"
                        >
                            <div class="wholesaler-badge-img">
                                <img
                                    :data-src="badge.image + '?auto=compress,format&q=65'"
                                    class="img-responsive px-4 py-4 lazy lazy-fade"
                                />
                            </div>
                            <p>
                                {{ badge.text }}
                            </p>
                        </div>
                    </div>

                    <div class="my-8">
                        <div ref="artists" class="anchor"></div>
                        <h2 class="h1 text-center">Apoiamos a arte independente</h2>

                        <AnimatedHeader
                            v-if="artistsNames"
                            class="hidden-md-down"
                            :labels="artistsNames"
                            :show-overlay="false"
                        >
                            <div class="wholesaler-artists-text bg-white px-4 py-4">
                                <p class="my-0">
                                    Somos tela em branco para dezenas de artistas convidados
                                    independentes, que usam nossa expertise para levar sua arte
                                    mundo afora. Já geramos cerca de
                                    <strong>R$ 1 milhão em royalties</strong>
                                    fomentando a arte nacional.
                                </p>
                            </div>
                        </AnimatedHeader>

                        <p class="hidden-md-up">
                            Somos tela em branco para dezenas de artistas convidados independentes,
                            que usam nossa expertise para levar sua arte mundo afora. Já geramos
                            cerca de
                            <strong>R$ 1 milhão em royalties</strong>
                            fomentando a arte nacional.
                        </p>
                    </div>

                    <div class="my-8">
                        <div ref="history" class="anchor"></div>
                        <h2 class="h1 text-center">Um bocado sobre a Chico Rei</h2>

                        <div class="hidden-md-up">
                            <div class="aspect aspect-xs-16-9 bg-default-1 rounded">
                                <img
                                    :data-src="`${imagesPath}MOODBOARD1.jpg?auto=compress,format&q=65&w=1000`"
                                    class="lazy lazy-fade"
                                />
                            </div>
                            <p>
                                Chico Rei é uma marca que emprega criatividade e tecnologia em
                                produtos que geram impacto social através de suas vendas. Entregamos
                                representatividade para quem veste, condições justas e humanas para
                                quem produz e impacto positivo para a comunidade ao redor. Com mais
                                de 13 anos de estrada, contamos com meio milhão de pessoas incríveis
                                vestindo nossas camisetas, espalhadas por mais de 3 mil cidades do
                                Brasil e 30 países pelo mundo. E como é “junto dos bão que a gente
                                fica mió”, queremos que você venha somar com a gente, espalhando
                                valores positivos por aí ;)
                            </p>
                        </div>

                        <div
                            class="hidden-md-down pos-relative aspect aspect-xs-16-9 bg-default-1 rounded"
                        >
                            <img
                                :data-src="`${imagesPath}MOODBOARD1.jpg?w=1250&auto=compress,format&q=65`"
                                class="lazy lazy-fade"
                            />
                            <div class="pos-absolute pos-bottom pos-right pos-left mb-4 mx-4">
                                <div class="pos-absolute pos-all bg-white fade-4 rounded"></div>
                                <p class="pos-relative py-4 px-4 my-0">
                                    Chico Rei é uma marca que emprega criatividade e tecnologia em
                                    produtos que geram impacto social através de suas vendas.
                                    Entregamos representatividade para quem veste, condições justas
                                    e humanas para quem produz e impacto positivo para a comunidade
                                    ao redor. Com mais de 13 anos de estrada, contamos com meio
                                    milhão de pessoas incríveis vestindo nossas camisetas,
                                    espalhadas por mais de 3 mil cidades do Brasil e 30 países pelo
                                    mundo. E como é “junto dos bão que a gente fica mió”, queremos
                                    que você venha somar com a gente, espalhando valores positivos
                                    por aí ;)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { partnerService } from '../../../common/service/resource';
    import AnimatedHeader from '../common/AnimatedHeader';
    import HorizontalScrollbar from '../common/container/HorizontalScrollbar';
    import { updateLazyLoad } from '../../../common/common';

    export default {
        name: 'WholesalerPage',

        components: { AnimatedHeader, HorizontalScrollbar },

        data() {
            const productTypes = [
                {
                    title: 'Camisetas',
                    images: {
                        desktop: 'bnr_b2b_bolsas.png',
                        mobile: 'bnr_b2b_bolsas_mobile.png',
                    },
                },
                {
                    title: 'Linha Infantil',
                    images: {
                        desktop: 'bnr_b2b_infantil.png',
                        mobile: 'bnr_b2b_infantil_mobile.png',
                    },
                },
                {
                    title: 'Bolsas e Mochilas',
                    images: {
                        desktop: 'bnr_b2b_camisetas.png',
                        mobile: 'bnr_b2b_camisetas_mobile.png',
                    },
                },
                {
                    title: 'Chico Rei Lab',
                    images: {
                        desktop: 'bnr_b2b_canecas.png',
                        mobile: 'bnr_b2b_canecas_mobile.png',
                    },
                },
            ];

            return {
                productsScrollEvent: null,
                partnersScrollEvent: null,

                productTypes,
                selectedProductType: productTypes[0],

                summary: [
                    { label: 'Produtos', ref: 'products' },
                    { label: 'Cadastre-se', ref: 'signUp' },
                    { label: 'Condições', ref: 'conditions' },
                    { label: 'Impacto Social', ref: 'social' },
                    { label: 'Coleções', ref: 'collections' },
                    { label: 'Galeria de Artistas', ref: 'artists' },
                    { label: 'Selos de Responsabilidade', ref: 'badges' },
                    { label: 'Nossa História', ref: 'history' },
                ],

                artistsNames: null,

                partnersBanners: [
                    '2021_02_paginalojistas_parceiros_alceu.png',
                    '2021_02_paginalojistas_parceiros_bowie.png',
                    '2021_02_paginalojistas_parceiros_lenine.png',
                ],

                imagesPath: this.$scope.CDN_IMAGES + '/images/site/2021/wholesaler/',

                conditions: [
                    {
                        icon: '2021_02_paginalojistas_icone_05.svg',
                        items: ['Basta um registro simples com o seu CNPJ;'],
                    },
                    {
                        icon: '2021_02_paginalojistas_icone_06.svg',
                        items: ['Projeto exclusivo para lojas físicas multimarcas;'],
                    },
                    {
                        icon: '2021_02_paginalojistas_icone_02.svg',
                        items: [
                            'Pagamento em até 90 dias por boleto* ou em até 4x com cartão de crédito**;',
                            'Pedido mínimo de R$500',
                        ],
                    },
                    {
                        icon: '2021_02_paginalojistas_icone_01.svg',
                        items: [
                            'Frete grátis em qualquer pedido;',
                            'Acesso ao nosso estoque dinâmico, sem necessidade de grades mínimas;',
                        ],
                    },
                    {
                        icon: '2021_02_paginalojistas_icone_03.svg',
                        items: [
                            'Fidelização: seu pedido gera 10% do valor em desconto para a sua próxima compra;',
                        ],
                    },
                    {
                        icon: '2021_02_paginalojistas_icone_04.svg',
                        items: [
                            'Não trabalhamos com consignação;',
                            'Preços disponíveis assim que fizer login com a sua conta;',
                        ],
                    },
                ],

                badges: [
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/algodao-sustentavel.png',
                        text: 'Todo o nosso algodão é registrado com o selo BCI (Better Cotton Initiative), garantindo sustentabilidade com ética para promover melhorias sociais, ambientais e econômicas. Reduzindo impactos ambientais na produção do algodão e estimulando a economia nas comunidades agrícolas.',
                    },
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/peta.svg',
                        text: 'Os produtos da linha de vestuário da Chico Rei não empregam qualquer tipo de exploração animal em seus processos de produção, seja nos componentes ou nas práticas. Isso tudo garantido e certificado por uma das maiores instituições de proteção animal no mundo.',
                    },
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/endeavor.png',
                        text: 'O programa Scale-Up Endeavor é uma plataforma de aceleração de empresas através de conexões que transformam empreendedores e negócios. Há 3 anos fazemos parte da rede mundial da Endeavor.',
                    },
                    {
                        image: 'https://chico-rei.imgix.net/images/site/2019/selos/eureciclo-colorido-2.svg',
                        text: 'Utilizamos o modelo de compensação ambiental para 100% das embalagens consumidas pela Chico Rei, gerando incentivos para elevar as taxas de reciclagem em todo o país.',
                    },
                ],
            };
        },

        created() {
            this.fetchArtists();
        },

        mounted() {
            updateLazyLoad();
        },

        methods: {
            fetchArtists() {
                partnerService
                    .query({
                        partner_type_id: 2,
                    })
                    .then((response) => (this.artistsNames = response.data.map((a) => a.name)))
                    .catch(() => {
                        // todo
                    });
            },

            scrollTo(ref) {
                cr$.byEl(this.$refs[ref]).scrollIntoView();
            },
        },
    };
</script>
